/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ReviewStatusEnum = (typeof ReviewStatusEnum)[keyof typeof ReviewStatusEnum];

export const ReviewStatusEnum = {
  not_started: 'not_started',
  pending: 'pending',
  finished: 'finished',
  complete: 'complete',
} as const;
